import { trackProductCart } from "./userEvents";

function pickDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (arguments[i] !== undefined && arguments[i] !== null) {
      return arguments[i];
    }
  }
  return null;
}

export function isLoggedIn() {
  return !!getStoredUser();
}

export function isGiftCardContext(store, keyword) {
  if (store && store.isGiftCard === true) {
    return true;
  }

  return String(keyword || "").trim().toLowerCase() === "gift card";
}

export function promptLoginModal() {
  if (typeof window === "undefined") {
    return;
  }

  var attempts = 0;
  var tryShow = function() {
    var jq = window.jQuery || window.$;
    if (jq && jq("#myModal").length) {
      jq("#myModal").modal("show");
      return;
    }

    attempts += 1;
    if (attempts < 25) {
      window.setTimeout(tryShow, 100);
    }
  };

  tryShow();
}

export function requireLogin() {
  if (isLoggedIn()) {
    return true;
  }

  promptLoginModal();
  return false;
}

export function requireLoginForProductDetail() {
  return requireLogin();
}

export var PRODUCT_DETAIL_ROUTE_NAMES = ["SingleProductView", "SearchSingle"];

export function getStoredUser() {
  try {
    var raw = localStorage.getItem("userData");
    if (!raw) {
      return null;
    }

    var userdata = JSON.parse(raw);
    var user = userdata.user;
    if (!user || !user.id) {
      return null;
    }

    var api_token = userdata.token || user.api_token || null;
    return { user_id: user.id, api_token: api_token };
  } catch (error) {
    return null;
  }
}

export function getCountryCode() {
  try {
    var raw = localStorage.getItem("countryCode");
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function openAffiliateUrl(url) {
  if (!url || typeof url !== "string") {
    return false;
  }

  var trimmed = url.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    return false;
  }

  window.open(trimmed, "_blank", "noopener,noreferrer");
  return true;
}

export function trackAffiliatePurchase(options) {
  options = options || {};
  var productId = options.productId;
  var userAction = options.userAction || "AddToCart";

  if (!productId) {
    return Promise.resolve();
  }

  var user = getStoredUser();
  var baseUrl = process.env.VUE_APP_URL;
  var countryCode = getCountryCode();
  var headers = {
    "content-type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };

  if (user && user.api_token) {
    headers.Authorization = "Bearer " + user.api_token;
  }

  var affiliatePromise = fetch(
    baseUrl + "customer/products/saveAffilativeNetwork/" + productId,
    { method: "get", headers: headers }
  ).catch(function() {});

  var clickstreamPromise = Promise.resolve();
  if (user && user.user_id) {
    clickstreamPromise = fetch(baseUrl + "customer/clickstream/SaveClickDatas", {
      method: "post",
      headers: headers,
      body: JSON.stringify({
        user_id: user.user_id,
        product_id: productId,
        clickstream_data: null,
        user_action: userAction,
        country_code: countryCode,
      }),
    }).catch(function() {});
  }

  trackProductCart(
    options.product || { productId: productId },
    options.source || "affiliate"
  );

  return Promise.all([affiliatePromise, clickstreamPromise]);
}

export function purchaseAffiliateProduct(options) {
  options = options || {};
  if (!openAffiliateUrl(options.url)) {
    return {
      opened: false,
      error: "This product does not have a valid purchase link.",
    };
  }

  trackAffiliatePurchase({
    productId: options.productId,
    product: options.product,
    source: options.source,
    userAction: options.userAction,
  });
  return { opened: true };
}

export function normalizeGiftCardProducts(items) {
  if (!items) {
    return [];
  }

  var list = Array.isArray(items) ? items : [items];
  return list.map(normalizeGiftCardProduct);
}

export function normalizeGiftCardProduct(item) {
  if (!item || typeof item !== "object") {
    return item;
  }

  var sku = pickDefined(item.sku, item.SKU);
  var linkurl = pickDefined(
    item.linkurl,
    item.linkURL,
    item.LinkUrl,
    item.url
  );
  var productname = pickDefined(item.productname, item.productName, item.name) || "";
  var imageurl = pickDefined(item.imageurl, item.imageURL, item.image);
  var saleprice = pickDefined(item.saleprice, item.salePrice, item.price);

  if (saleprice && typeof saleprice === "object") {
    saleprice = pickDefined(saleprice["#text"], saleprice[0]);
  }

  var price = item.price != null ? item.price : 0;
  if (price && typeof price === "object") {
    price = pickDefined(price["#text"], price[0], 0);
  }

  return Object.assign({}, item, {
    sku: sku,
    linkurl: linkurl,
    productname: productname,
    imageurl: imageurl,
    saleprice: saleprice,
    price: price,
    productId: pickDefined(item.productId, sku ? "rakuten-" + sku : null),
  });
}

export function buildGiftCardKeyword(extraKeyword) {
  var base = "gift card";
  if (extraKeyword && String(extraKeyword).trim()) {
    return base + " " + String(extraKeyword).trim();
  }
  return base;
}

export function fetchGiftCards(options) {
  options = options || {};
  var url = process.env.VUE_APP_URL + "customer/search/gift_cards";

  return fetch(url, {
    method: "post",
    headers: {
      "content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      keyword: options.keyword || "gift card",
      page: options.page || 1,
    }),
  }).then(function(res) {
    return res.json();
  });
}

export function searchGiftCards(options) {
  return fetchGiftCards(options).then(function(data) {
    if (!data || data.status !== true || !data.response) {
      var message =
        (data && data.message) || "Unable to load gift cards right now.";
      return Promise.reject(new Error(message));
    }

    return {
      items: normalizeGiftCardProducts(data.response.item),
      totalPages: data.response.TotalPages,
    };
  });
}

export function buildUserData(customer, token) {
  return {
    user: customer,
    token: token || (customer && customer.api_token) || null,
    status: true,
  };
}
